import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { BodyText, theme, useResponsive } from '@sg/garnish';

import { useTrademark } from '../../../hooks/useTrademark';
import { DebugMenuTrigger } from '../../DebugMenu';

// ─────────────────────────────────────────────────────────────────────────────

export const OrganizationLinksFooterCopyright = (props: Props) => {
  const { palette } = props;

  const { formatMessage } = useIntl();
  const trademark = useTrademark();

  const { minWidth } = useResponsive();
  const alignmentStyle = minWidth.isMD ? styles.alignmentMD : undefined;
  const textStyle = palette === 'dark' ? styles.lightText : styles.darkText;

  return (
    <View>
      <BodyText style={[textStyle, alignmentStyle]}>
        {formatMessage(messages.footerCopyright, { year: CURRENT_YEAR })}
      </BodyText>

      {trademark ? (
        <BodyText style={[textStyle, styles.trademark, alignmentStyle]}>{trademark}</BodyText>
      ) : null}

      <BodyText style={[textStyle, alignmentStyle]}>
        <DebugMenuTrigger style={textStyle} />
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  footerCopyright: {
    defaultMessage: '©sweetgreen {year}',
    description: 'Footer | Copyright',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const CURRENT_YEAR = new Date().getFullYear();

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  alignmentMD: {
    textAlign: 'right',
  },
  darkText: {
    color: theme.colors.DARK_KALE,
  },
  lightText: {
    color: theme.colors.WHITE,
  },
  trademark: {
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  palette: 'light' | 'dark';
};
